import React from "react";
import styled from "styled-components";
import Styles from "@themes/Styles";

const SelectorElementWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    width: 100%;
    border-radius: ${Styles.borderRadiusExtraSharp};
    border-top: 1px solid ${(props) => props.theme.borderPrimary};

    background-color: ${(props) => props.theme.backgroundPrimary};
    &:hover {
        background-color: ${(props) => props.theme.hoverPrimary};
        cursor: pointer;
    }
`;

interface LifeAtDropdownSelectorElementProps {
    /**
     * Elements to display in one row of the dropdown.
     */
    children: JSX.Element | JSX.Element[];
    /**
     * Optional, action to perform when this item is selected in a
     * LifeAtDropdownSelector component.
     */
    handleSelect?: () => void;
}
export default function LifeAtDropdownSelectorElement(props: LifeAtDropdownSelectorElementProps) {
    return <SelectorElementWrapper onClick={props.handleSelect}>{props.children}</SelectorElementWrapper>;
}
